<template lang="pug">
.cont.pa-4(v-cloak, @dragover.prevent="showDrag")
  .upload-file.ma-4(
    v-if="showDragOver",
    v-cloak,
    @drop.prevent="addDropFile",
    @dragover.prevent="showDrag",
    @dragleave.prevent="hideDrag"
  ) Drop files here to upload them
  .d-flex.align-center.mw
    v-file-input(multiple, label="Drag files or upload manually")
    v-btn.ml-4(color="primary") upload
  v-row
    file(
      v-for="file in files",
      :key="file.id",
      :data="file",
      :members="companyMembers"
    )
</template>

<script>
import File from "@/components/Documents/File.vue";

export default {
  components: {
    File,
  },

  data: () => ({
    files: [],
    showDragOver: false,
    companyMembers: [],
  }),

  mounted() {
    this.loadFiles();
    this.loadCompanyMembers();
  },

  methods: {
    loadCompanyMembers() {
      this.axios.get("/company/members").then((resp) => {
        this.companyMembers = resp.data;
      });
    },

    hideDrag() {
      this.showDragOver = false;
    },

    showDrag() {
      this.showDragOver = true;
    },

    addDropFile(e) {
      this.hideDrag();
      e.dataTransfer.files.forEach((f, ind) => {
        var form = new FormData();
        form.append("file", f);
        this.files.push({
          ID: ind * -1,
          Name: f.Name,
          prc: 1,
          OwnerID: 0,
        });
        var inArrInd = this.files.length - 1;
        const config = {
          onUploadProgress: (progressEvent) => {
            var percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            this.$set(this.files, inArrInd, {
              ID: ind * -1,
              Name: f.name,
              prc: percentCompleted,
              OwnerID: 0,
            });
          },
        };
        this.axios.post("/files", form, config).then((resp) => {
          this.$set(this.files, inArrInd, resp.data);
        });
      });
      // console.log(Array.from(e.dataTransfer.files));
    },

    loadFiles() {
      this.axios.get("/files/list").then((resp) => {
        this.files = resp.data;
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.mw
  max-width: 650px

.cont
  position: relative
  min-height: 100vh

.upload-file
  position: absolute
  z-index: 2
  top: 0
  bottom: 0
  right: 0
  left: 0
  border: 10px dashed
  border-radius: 25px
  background: #ffffff80
  font-size: 52px
  display: flex
  justify-content: center
  align-items: center
</style>